import PzCheckoutProviders from './pz_checkout_providers/templates/pz_checkout_providers';

export default PzCheckoutProviders;